import Icon from 'components/icons/Icon';

const CarouselArrow = (props) => {
  return (
    <Icon width="20" height="20" viewBox="0 0 20 20" {...props}>
      <path
      fill="currentColor"
      d="M17.9167 9.57962C18.0292 9.69214 18.0924 9.84475 18.0924 10.0039C18.0924 10.163 18.0292 10.3156 17.9167 10.4281L13.0143 15.3305C12.78 15.5648 12.4001 15.5648 12.1658 15.3305C11.9315 15.0962 11.9315 14.7163 12.1658 14.482L16.0439 10.6039L2.46115 10.6039C2.12978 10.6039 1.86116 10.3353 1.86116 10.0039C1.86116 9.67251 2.12978 9.40388 2.46115 9.40388L16.0439 9.40389L12.1658 5.5258C11.9315 5.29149 11.9315 4.91159 12.1658 4.67727C12.4001 4.44296 12.78 4.44296 13.0143 4.67727L17.9167 9.57962Z"
    />
    </Icon>
  );
};

export default CarouselArrow;
